import { COURSE_API } from 'modules/courses/courses/curriculum/api/course-curriculum-api'
import { CourseCurriculumInterface } from 'modules/courses/courses/curriculum/types/curriculum-interface'
import { CourseId } from 'modules/courses/courses/types/course-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules'
import useUser from 'shared/hooks/use-user'

export function useClassicCourseCurriculum(id?: CourseId, isFetchAllowed = true) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CourseCurriculumInterface>({
    method: RequestMethodsEnum.get,
  })

  const { revalidateModules } = useRevalidateModules()

  const swrResult = useControlledSwr(
    () =>
      user &&
      id && [`${COURSE_API}/${id}/curriculum`, RequestModuleEnum.MembershipCourseCurriculum],
    fetcher,
    undefined,
    isFetchAllowed,
  )

  const revalidateCourseCurriculum = async (hardRevalidate?: boolean) => {
    await revalidateModules([RequestModuleEnum.MembershipCourseCurriculum], hardRevalidate)
  }

  return { ...swrResult, revalidateCourseCurriculum }
}
